import type { AxiosInstance } from 'axios'
import type { IFactoryFunctionRequest, IUser } from '@bc-library/interface'
import { EMethod } from '@bc-library/interface'
import { resourceApi } from '@/services/api'
import { useUserStore } from '@/config/store/userStore'
import router from '@/config/router'
import useAxios from '@/services/api/useAxios'
import { API_MAIN_VERSION, BASE_URL } from '@/config/constantes'
import { useApplicationStore } from '@/config/store/applicationStore'

const resource = 'users'

const login = (axios: AxiosInstance) => async ({ pageOptions, ...data }: any) => {
  
  return axios.post(`${BASE_URL}/auth/local`, data)
  

}

const updateUser = (axios: IFactoryFunctionRequest<IUser, Partial<IUser>>) => (userId: string, userToSend: Partial<IUser>) => {
  return axios({
    method: EMethod.put,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/${userId}`,
    data: userToSend,
  })
}

const updateEmail = (axios: IFactoryFunctionRequest<IUser, Partial<IUser>>) => (userId: string, userToSend: { email: string }) => {
  return axios({
    method: EMethod.put,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/${userId}/updateMail`,
    data: userToSend,
  })
}

const searchUserPicture = (axios: IFactoryFunctionRequest<IUser, { name: string }>) => (search: { name: string }) => {
  return axios({
    method: EMethod.post,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/getGoogleImages`,
    data: search,
  })
}

const changeUserPassword = (axios: IFactoryFunctionRequest<any, any>) => (userId: string, { oldPassword, newPassword }: { oldPassword?: string; newPassword: string }) => {
  return axios({
    method: EMethod.patch,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/v2/changePassword/${userId}`,
    data: {
      oldPassword,
      newPassword,
    },
  })
}

const updateLocale = (axios: IFactoryFunctionRequest<any, any>) => (lang: string) => {
  return axios({
    method: EMethod.patch,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/v2/lang`,
    data: {
      lang,
    },
  })
}

const recoverPassword = (axios: AxiosInstance) => (email: string) => {
  return axios({
    method: EMethod.patch,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/v2/recoverPassword`,
    data: {
      email,
    },
  })
}

export default (axios: AxiosInstance) => ({
  login: login(axios),
  recoverPassword: recoverPassword(axios),
  updateUser: updateUser(useAxios(axios)),
  searchUserPicture: searchUserPicture(useAxios(axios)),
  updateEmail: updateEmail(useAxios(axios)),
  changeUserPassword: changeUserPassword(useAxios(axios)),
  updateLocale: updateLocale(useAxios(axios)),
})
